import React from 'react';

const Loader = () => (
  <div className="loader">
    <div className="loader-content">
      <div className="loader-circle"></div>
      <h2>LOADING</h2>
    </div>
  </div>
);

export default Loader;
